import React from 'react';
import Button from '@material-ui/core/Button';

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import { Alert } from '@material-ui/lab';


const ConfirmEditLossDialog = ({ isOpen, message, handleReturnClick, handleDisposeClick }) => {

  return (
    <Dialog open={isOpen} aria-labelledby="confirm-edit-loss-dialog">
      <DialogTitle id="confirmeditloss-dialog">Confirm Edit loss</DialogTitle>
      <DialogContent>
        <Alert severity="error">{message}</Alert>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleReturnClick} color="primary">
          Return To Edit
          </Button>
        <Button onClick={handleDisposeClick} color="primary">
          Discard Current Edit
          </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmEditLossDialog